import { Box } from '@mui/material';
import { SaveStatus } from './types';
import { useConfigurationSaveStatus } from './useConfigurationSaveStatus';
import styles from './ConfigurationSaveStatus.module.scss';

interface ConfigurationSaveStatusProps {
  saveStatus: SaveStatus;
}

export const ConfigurationSaveStatus = ({
  saveStatus,
}: ConfigurationSaveStatusProps) => {
  const { isVisible, message, statusClass } = useConfigurationSaveStatus({
    saveStatus,
  });

  if (!isVisible) {
    return null;
  }

  return (
    <Box className={`${styles.saveStatusBadge} ${styles[statusClass]}`}>
      {message}
    </Box>
  );
};
